import React, { useEffect, useState } from 'react';
import { RouteComponentProps, useLocation } from '@reach/router';
import queryString from 'query-string';
import Page from 'components/shared/Page';
import { UploadDocuments } from './UploadDocuments';
import { InfoTable } from 'components/infoTable/infoTable';
import { endpoints } from '../../endpoints.config';
import { MyDocumentsMenuOptions } from './MyDocumentsMenuOptions';
import {
  selectUpdateMyDocumentsList,
  setUpdateMyDocumentsList,
  setMyDocumentsListSubjectId,
  selectUpdateMyDocumentsListSubjectId,
} from 'reducers/misc';
import { useDispatch, useSelector } from 'react-redux';
import WarningIcon from '../../images/Icon_Warning.png';
import { CreateFolder } from './CreateFolder';

export const MyDocuments: React.FC<RouteComponentProps> = () => {
  const updateListStatus: boolean = useSelector(selectUpdateMyDocumentsList);
  const updateListSubjectId: number | null = useSelector(
    selectUpdateMyDocumentsListSubjectId
  );

  const dispatch = useDispatch();
  const setUpdateList = (status: boolean) =>
    dispatch(setUpdateMyDocumentsList(status));

  const [isPanelClosed, setIsPanelClosed] = useState<boolean>(false);
  const [openUploadDocumentPopup, setOpenUploadDocumentPopup] =
    useState<boolean>(false);
  const [openAddFolderPopup, setOpenAddFolderPopup] = useState<boolean>(false);

  const location = useLocation();

  useEffect(() => {
    const queryParams: any = location
      ? queryString.parse(location.search)
      : undefined;

    if (queryParams.subjectsid) {
      dispatch(setMyDocumentsListSubjectId(queryParams.subjectsid));
    }
  }, []);

  if (!updateListSubjectId) {
    return (
      <Page>
        <div className="PageContent MyDocumentsPage WidthContent">
          <div className="InfoTableHdr">
            <div className="LeftSide">
              <h1 className="PageTitle">Documents</h1>
              <div className="LineSpacer4"></div>
              <h2>School Documents</h2>
            </div>
          </div>
          <div className="InfoTableContainer">
            <div className="FailedMsg">
              <div className="MsgContainer Error">
                <div className="Img">
                  <img src={WarningIcon} alt="Warning" />
                </div>
                <div className="Txt">
                  An error occurred while loading the document list. Please come
                  back and try again later.
                </div>
              </div>
            </div>
          </div>
        </div>
      </Page>
    );
  }

  return (
    <Page iFramePage={true}>
      <div className="PageContent MyDocumentsPage WidthContent">
        <InfoTable
          documentListTable={true}
          title="My Documents"
          listUrl={endpoints.myDocuments.list}
          firstColWidth={300}
          firstColWidthSm={80}
          buttonText={'Create Folder'}
          secondButtonText={'Upload File'}
          buttonFunc={() => setOpenAddFolderPopup(true)}
          secondButtonFunc={() => setOpenUploadDocumentPopup(true)}
          updateListStatus={updateListStatus}
          setUpdateList={setUpdateList}
          setIsPanelClosed={setIsPanelClosed}
          isPanelClosed={isPanelClosed}
          spinnerColour={'#FFFFFF'}
          showSecondPagination={true}
        >
          <MyDocumentsMenuOptions />
        </InfoTable>

        {/* Upload Document Pop-up  */}
        {openUploadDocumentPopup && (
          <UploadDocuments
            panelOpen={openUploadDocumentPopup}
            togglePanelOpen={setOpenUploadDocumentPopup}
          />
        )}
        {openAddFolderPopup && (
          <CreateFolder
            panelOpen={openAddFolderPopup}
            togglePanelOpen={setOpenAddFolderPopup}
          />
        )}
      </div>
    </Page>
  );
};
